import DisabledComment from './DisabledComment';
export default DisabledComment;
//# sourceMappingURL=index.js.map